import { useTranslation } from "react-i18next"
import { Button, Form, Row } from 'react-bootstrap'
import { useEffect, useState } from "react"
import Select from "react-select"
import customStyles from "../../../components/design/select"

export default function FormPlot({submit, isNew, inputChange, state, farms, crops}) {
    const { t } = useTranslation()

    const [farmsOptions, setFarmsOptions] = useState([])
    const [cropsOptions, setCropsOptions] = useState([])
    const [plotFarm, setFarm] = useState('')
    const [plotCrops, setCrops] = useState('')

    const handleSelectFarmsChange = (e) => {
        inputChange({target:{name: 'farmselected', value: e.value}})
    }

    useEffect(()=>{
        let farmsAvailable = []
        let farmsSelected = []
        
        farms?.forEach(farm => {
            let object = {value: farm._id, label: farm.name}
            farmsAvailable.push(object)
            if (state.farmselected && state.farmselected.indexOf(farm._id) !== -1) {
                farmsSelected.push(farmsAvailable[farmsAvailable.length - 1])
            }
        })
        setFarmsOptions(farmsAvailable)
        setFarm(farmsSelected)
    },[state, farms])

    const handleSelectCropsChange = (selectedOptions) => {
        let values = []
        selectedOptions.forEach(option => {
            values.push(option.value)
        })
        inputChange({target:{name: 'cropsselected', value: values}})
    }

    useEffect(()=>{
        let cropsAvailable = []
        let cropsSelected = []
        
        crops?.forEach(crop => {
            let object = {value: crop._id, label: crop.name}
            cropsAvailable.push(object)
            if (state.cropsselected && state.cropsselected.indexOf(crop._id) !== -1) {
                cropsSelected.push(cropsAvailable[cropsAvailable.length - 1])
            }
        })
        setCropsOptions(cropsAvailable)
        setCrops(cropsSelected)
    },[state, crops])

    return (
        <>
            <Form onSubmit={submit}>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('plots.name')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='name' 
                        value={state.name || state.nameEdit ||  ''}
                        placeholder={t('plots.name')}
                        onChange={inputChange}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('plots.farms')}</Form.Label>
                    <Select onChange={handleSelectFarmsChange}
                        name="farms"
                        placeholder={t('plots.farms')}
                        options={farmsOptions}
                        value={plotFarm}
                        styles={customStyles}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('plots.crops')}</Form.Label>
                    <Select isMulti onChange={handleSelectCropsChange}
                        name="crops"
                        placeholder={t('plots.crops')}
                        options={cropsOptions}
                        value={plotCrops}
                        styles={customStyles}
                        required
                    />
                </Form.Group>
                <Row className="text-left custom-card-header-list">
                    {
                        isNew === false
                        ?
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('plots.update')}</Button>
                        :
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('plots.new')}</Button>
                    }
                </Row>
            </Form>
        </>
    )    
}
